import { Carousel, CarouselType } from './Carousel'
import { Testimony } from './Content/Testimonial'

const testimonials: Testimony[] = [
  {
    quote: `I've finally been diagnosed with something that would explain the last ten years of my life. These doctors were the first to really listen to me and have saved my life. I've been telling all of my friends about Allara Health!`,
    author: 'Devonya O.',
  },
  {
    quote: `Allara is personal, professional and unique. They have a comprehensive app with communication, solutions and other valuable resources. Allara providers give you real answers on your time. 10/10 would recommend!`,
    author: 'Faith N.',
  },
  {
    quote: `Allara gave me the PCOS diagnosis I had been waiting 22 years for. I had always known something in my body was a little off. Allara gave me the answers and validation I had been looking for nearly my whole life.`,
    author: 'Elissa S.',
  },
]

export const TestimonialCarousel = () => {
  return <Carousel type={CarouselType.TESTIMONIAL} list={testimonials} />
}
